export const COLLAPSE_DIRECTIVE_LOCALE = {
    expand: 'expand',
    fold: 'fold'
}